if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.primaryButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.stickyButton = this.querySelector('[data-sticky-button]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.priceSource = document.querySelector(`#price-${this.sectionId}`);
        this.variantInput = document.querySelector(`#product-form-${this.sectionId} .product-variant-id`);
        this.description = document.querySelector('.product__description');
        this.isPrimaryVisible = true;
        this.isDescriptionVisible = false;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        if (!this.primaryButton || !this.stickyButton) return;

        this.syncButton();
        this.syncPrice();

        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.primaryButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
        });

        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true });
        }

        if (this.variantInput) {
          this.variantObserver = new MutationObserver(() => this.syncVariant());
          this.variantObserver.observe(this.variantInput, { attributes: true, attributeFilter: ['value'] });
          this.syncVariant();
        }

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            this.isPrimaryVisible = entry.isIntersecting;
            this.updateVisibility();
          },
          { threshold: 0.15 }
        );
        this.visibilityObserver.observe(this.primaryButton);

        if (this.description) {
          this.descriptionObserver = new IntersectionObserver(
            ([entry]) => {
              this.isDescriptionVisible = entry.isIntersecting;
              this.updateChatVisibility();
            },
            { rootMargin: '-70% 0px 0px 0px' }
          );
          this.descriptionObserver.observe(this.description);
        }

        this.mobileQuery.addEventListener('change', () => {
          this.updateVisibility();
          this.updateChatVisibility();
        });
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.variantObserver?.disconnect();
        this.descriptionObserver?.disconnect();
        document.body.classList.remove('product-sticky-atc-visible');
        document.body.classList.remove('product-chat-avoid-description');
      }

      syncButton() {
        const disabled = this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true';
        this.stickyButton.disabled = disabled;
        const label = this.primaryButton.querySelector('span')?.textContent?.trim();
        if (label) this.stickyButton.querySelector('span').textContent = label;
      }

      syncPrice() {
        if (!this.priceSource || !this.stickyPrice) return;
        const price = this.priceSource.querySelector('.price__sale .price-item--sale, .price-item--regular');
        if (price?.textContent) this.stickyPrice.textContent = price.textContent.trim();
      }

      syncVariant() {
        if (!this.variantInput || !this.stickyButton) return;
        this.stickyButton.dataset.ggVariantId = this.variantInput.value;
      }

      updateVisibility() {
        const shouldShow = this.mobileQuery.matches && !this.isPrimaryVisible;
        this.hidden = !shouldShow;
        this.setAttribute('aria-hidden', String(!shouldShow));
        document.body.classList.toggle('product-sticky-atc-visible', shouldShow);
        if (shouldShow) {
          document.documentElement.style.setProperty('--product-sticky-atc-height', `${this.offsetHeight}px`);
        }
      }

      updateChatVisibility() {
        const shouldAvoidDescription = this.mobileQuery.matches && this.isDescriptionVisible;
        document.body.classList.toggle('product-chat-avoid-description', shouldAvoidDescription);
      }
    }
  );
}
